import { Attributes, Misc, Validation, ValueObject } from '@singularsystems/neo-core';
import InterestRateType from '../Rates/InterestRateType';
import { CompoundingType } from '../Dividends/CompoundingType.enum';
import { InterestCalculationType } from '../Rates/InterestCalculationType.enum';
import { BusinessDayConvention } from '../Dividends/BusinessDayConvention.enum';

export default class CalculationOptions extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public compoundOnDividend: CompoundingType = CompoundingType.None;

    public compoundOnRateChange: boolean = false;

    public paymentDateConvention: BusinessDayConvention = BusinessDayConvention.Following;

    @Attributes.Integer()
    public paymentDateOffset: number = 0;

    @Attributes.Nullable()
    public interestRateTypeId: number | null = null;

    @Attributes.Serialisation(Misc.SerialiseType.FullOnly)
    @Attributes.ChildObject(InterestRateType)
    public interestRateType: InterestRateType | null = null;

    @Attributes.Nullable()
    public calculationTypeId: number | null = null;

    public rateGrossedUp: boolean = false;

    @Attributes.Nullable()
    @Attributes.Float(10)
    public spread: number | null = null;

    // Client only properties / methods

    public get spreadRequired(): boolean {
        return this.interestRateType?.interestCalculationType === InterestCalculationType.Zaronia;
    }

    protected static addBusinessRules(rules: Validation.Rules<CalculationOptions>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.spreadRequired && c.spread == null, "Credit adjustment spread is required.").onProperties(c => c.spread);
        rules.failWhen(c => c.paymentDateOffset < 0, "Payment date offset cannot be a negative number of days.").onProperties(c => c.paymentDateOffset);
    }

    public toString(): string {
        return "Investment Values";
    }
}